import { ResultadoImpresion } from '../../services/printer.service';

/**
 * Imprime un documento HTML completo con `window.print()` desde un iframe oculto, para
 * que la caja no cambie de página. Sin diálogo si Chrome arrancó con `--kiosk-printing`.
 *
 * `window.print()` no dice si el papel salió (decisión de Santiago: se acepta perderlo),
 * así que el resultado es `enviado`, nunca `confirmado`.
 */
export const imprimirEnNavegador = {
  async imprimir(html: string): Promise<ResultadoImpresion> {
    if (typeof document === 'undefined') {
      return { estado: 'no_impreso', motivo: 'error_agente', detalle: 'Sin documento donde imprimir' };
    }
    const anterior = document.getElementById('suresell-impresion');
    anterior?.remove();
    const marco = document.createElement('iframe');
    marco.id = 'suresell-impresion';
    marco.setAttribute('aria-hidden', 'true');
    marco.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(marco);
    try {
      const doc = marco.contentDocument;
      const ventana = marco.contentWindow;
      if (!doc || !ventana) throw new Error('El navegador no dejó preparar la impresión');
      doc.open();
      doc.write(html);
      doc.close();
      ventana.focus();
      ventana.print();
      return { estado: 'enviado' };
    } catch (e) {
      marco.remove();
      return { estado: 'no_impreso', motivo: 'error_agente', detalle: e instanceof Error ? e.message : String(e) };
    }
  },
};
